import { Banner as KitconceptDsgvoBanner } from '@kitconcept/volto-dsgvo-banner/components';
import CsjDsgvoBanner from '../components/CookieBanner/CsjDsgvoBanner';
import DsgvoAnalyticsBridge from '../components/CookieBanner/DsgvoAnalyticsBridge';

const CSJ_DSGVO_BANNER_EXTRA = 'csj-dsgvo-banner';
const CSJ_DSGVO_ANALYTICS_EXTRA = 'csj-dsgvo-analytics';

export default function installDsgvo(config) {
  config.settings.DSGVOBanner = {
    ...(config.settings.DSGVOBanner || {}),
    showBanner: true,
    showTechnicallyRequired: true,
    modules: ['tracking', 'facebook'],
    privacy_url: {
      ca: '/ca/cookies',
      es: '/es/cookies',
      en: '/en/cookies',
    },
    tracker: {
      type: 'google',
      id: 'UA-22717907-1',
      gaOptions: {
        anonymizeIp: true,
      },
      gtagOptions: {},
    },
    cssClasses: {
      bannerAgreeButton:
        'csj-cookie-banner__btn csj-cookie-banner__btn--primary',
      bannerAdjustButton:
        'csj-cookie-banner__btn csj-cookie-banner__btn--configure',
      bannerRejectButton:
        'csj-cookie-banner__btn csj-cookie-banner__btn--secondary',
    },
    bannerComponent: CsjDsgvoBanner,
  };

  const bannerComponent =
    config.settings.DSGVOBanner.bannerComponent || CsjDsgvoBanner;

  let removedDefaultBanner = false;
  config.settings.appExtras = (config.settings.appExtras || []).filter(
    (extra) => {
      if (
        extra.name === CSJ_DSGVO_BANNER_EXTRA ||
        extra.name === CSJ_DSGVO_ANALYTICS_EXTRA
      ) {
        return false;
      }
      if (
        !removedDefaultBanner &&
        extra.match === '' &&
        !extra.name &&
        (extra.component === KitconceptDsgvoBanner || bannerComponent)
      ) {
        removedDefaultBanner = true;
        return false;
      }
      return true;
    },
  );

  config.settings.appExtras.push(
    {
      match: '',
      name: CSJ_DSGVO_BANNER_EXTRA,
      component: bannerComponent,
    },
    {
      match: '',
      name: CSJ_DSGVO_ANALYTICS_EXTRA,
      component: DsgvoAnalyticsBridge,
    },
  );

  return config;
}
